import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UtilsService } from '../../services/utils.service';

/**
 * Questo componente Ã¨ una semplice card
 */
@Component({
  selector: 'fb-card',
  template: `
    <div class="card">
      <div class="title" (click)="toggle.emit(1234)">{{title}}</div>
      <div class="description" *ngIf="opened">
        <ng-content></ng-content>
        <hr>
        {{utils.title}}
      </div>
    </div>
  `,
  styles: [`
    .card { border: 1px solid black; border-radius: 10px}
    .title { padding: 10px }
    .description { padding: 10px; font-style: italic;}
  `]
})
export class CardComponent {
  /**
   * The title of the card
   */
  @Input() title: string;
  /**
   * Represents if panel is opened or not
   */
  @Input() opened: boolean;
  /**
   * Invocato quando l'utente clicca sulla titlebar
   */
  @Output() toggle: EventEmitter<any> = new EventEmitter();

  constructor(public utils: UtilsService) {}
}
